import { STATUS } from "@/constant/statusConstants";
import createLocalizationsSchema from "@/schema/WebDataManagement/MasterData/Localizations/createLocalizationsSchema";
import * as Yup from "yup";

const getBlogCategorySchema = (localeCodes, isEdit = false) =>
  Yup.object().shape({
    status: Yup.string()
      .label("Status")
      .required()
      .oneOf(Object.values(STATUS)),
    localizations: createLocalizationsSchema(localeCodes),
    icon: Yup.mixed()
      .label("Inactive Icon")
      .when([], {
        is: () => isEdit,
        then: (schema) => schema.nullable(),
        otherwise: (schema) => schema.required(),
      }),
    icon_active: Yup.mixed()
      .label("Active Icon")
      .when([], {
        is: () => isEdit,
        then: (schema) => schema.nullable(),
        otherwise: (schema) => schema.required(),
      }),
  });

export default getBlogCategorySchema;
